/**
 * Custom Country Selector JavaScript
 * Handles country selection, form submission, and special redirects
 */

class CustomCountrySelector {
  constructor() {
    this.init();
  }

  init() {
    const forms = document.querySelectorAll('[data-country-selector-form]');
    
    forms.forEach(form => {
      const select = form.querySelector('[data-country-select]');
      const languageCodeInput = form.querySelector('[data-language-code]');
      const countryFlag = form.querySelector('[data-country-flag]');
      
      if (select) {
        select.addEventListener('change', (event) => {
          this.handleCountrySelect(event, form, languageCodeInput, countryFlag);
        });
      }
    });
  }

  /**
   * Handle country selection change event
   * @param {Event} event - The change event
   * @param {HTMLFormElement} form - The form element
   * @param {HTMLInputElement} languageCodeInput - The language code hidden input
   * @param {HTMLImageElement} countryFlag - The country flag image
   */
  handleCountrySelect(event, form, languageCodeInput, countryFlag) {
    const countryCode = event.target.value;
    
    if (!countryCode) return;

    // Handle special redirects first
    if (countryCode.startsWith('http')) {
      console.log('Redirecting to', countryCode);
      window.location.href = countryCode;
      return;
    }

    this.setLanguageCode(countryCode, languageCodeInput);

    // Handle special country cases
    switch (countryCode) {
      case 'US':
        window.location.href = 'https://us.dryrobe.com/?country=US';
        return;
      
      case 'DE2':
        // Store selection in localStorage for redirect modal dismissal
        this.storeCountrySelection({ handle: 'DE2', name: 'Germany (English)' });
        window.location.href = `${window.location.origin}/en-de`;
        return;
    }

    // Update flag if available
    this.updateCountryFlag(countryCode, countryFlag);

    // Store selection in localStorage for redirect modal dismissal
    this.storeCountrySelection({ handle: countryCode, name: event.target.selectedOptions[0].text });

    // Submit form after a short delay
    setTimeout(() => {
      form.submit();
    }, 50);
  }

  /**
   * @param {string} countryCode - The selected country code
   * @param {HTMLInputElement} languageCodeInput - The language code input
   */
  setLanguageCode(countryCode, languageCodeInput) {
    if (!languageCodeInput) return;

    let languageCode = 'en'; // default

    switch (countryCode) {
      case 'DE':
        languageCode = 'de';
        break;
      case 'FR':
        languageCode = 'fr';
        break;
      default:
        languageCode = 'en';
        break;
    }

    languageCodeInput.value = languageCode;
  }

  /**
   * Update country flag image
   * @param {string} countryCode - The selected country code
   * @param {HTMLImageElement} countryFlag - The country flag image
   */
  updateCountryFlag(countryCode, countryFlag) {
    if (!countryFlag) return;
    const currentSrc = countryFlag.getAttribute('src') || '';
    const url = new URL(currentSrc, window.location.origin);

    // Replace only the filename while preserving path and query string
    const parts = url.pathname.split('/');
    parts[parts.length - 1] = `${countryCode.toLowerCase()}.svg`;
    url.pathname = parts.join('/');

    countryFlag.src = url.toString();
  }

  /**
   * Store country selection in localStorage for redirect modal dismissal
   * @param {Object} country - The selected country object
   */
  storeCountrySelection(country) {
    try {
      localStorage.setItem('redirect-modal-dismissed', JSON.stringify(country));
    } catch (error) {
      console.warn('Could not store country selection in localStorage:', error);
    }
  }
}

// Initialize once
(function initOnce() {
  const init = () => {
    if (window.__CUSTOM_COUNTRY_SELECTOR_INIT__) return;
    window.__CUSTOM_COUNTRY_SELECTOR_INIT__ = true;
    new CustomCountrySelector();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
